import type { DefaultTheme } from 'styled-components'
import { BASE_THEME } from './BaseTheme'

export const TEACHING_THEME: DefaultTheme = {
  ...BASE_THEME,
  showFormFieldRequirednessIndicators: false
}

export default TEACHING_THEME
